import { FacebookLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { applyDayJsConfig } from '@core/config/dayjs.config';
import { handleViteModuleLoadError } from '@core/config/vite-error-handler.config';
import { currencyProvider } from '@core/currency/currency.token';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { TRANSLATION_LANGUAGES_DEFAULT } from '@core/internationalization/internationalization.types';
import { environment } from '@environments/environment';
import { provideTranslateService } from '@ngx-translate/core';
import { APP_ROUTES } from '@routes/app.routes';
import { SnakeToPipe } from '@shared/pipes/snake-to.pipe';
import { CookieService } from 'ngx-cookie-service';
import { provideEchartsCore } from 'ngx-echarts';

import * as echarts from 'echarts/core';
import { LineChart, BarChart, PieChart, HeatmapChart, FunnelChart } from 'echarts/charts';
import {
    GridComponent,
    TooltipComponent,
    LegendComponent,
    DataZoomComponent,
    MarkLineComponent,
    MarkAreaComponent,
    VisualMapComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
    LineChart,
    BarChart,
    PieChart,
    HeatmapChart,
    FunnelChart,
    GridComponent,
    TooltipComponent,
    LegendComponent,
    DataZoomComponent,
    MarkLineComponent,
    MarkAreaComponent,
    VisualMapComponent,
    CanvasRenderer,
]);

handleViteModuleLoadError();
applyDayJsConfig();

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: TRANSLATION_LANGUAGES_DEFAULT },
        provideAnimationsAsync(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(APP_ROUTES, withComponentInputBinding()),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideNativeDateAdapter(),
        // No service worker in TwinnyX (Twinny's web push is a mobile-PWA feature), but the
        // auth/push services brought from twinny-app inject SwPush, so it stays registered off.
        provideServiceWorker('ngsw-worker.js', { enabled: false }),
        SnakeToPipe,
        CookieService,
        currencyProvider,
        provideEchartsCore({ echarts }),
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider(environment.facebookClientId),
                    },
                ],
                onError: err => {
                    console.error(err);
                },
            } as SocialAuthServiceConfig,
        },
        provideTranslateService({
            defaultLanguage: TRANSLATION_LANGUAGES_DEFAULT,
        }),
    ],
};
